<div class="p-grid p-align-start vertical-container mt-1 container-fullsize">
    <!-- <div class="col-md-12 text-center" style="margin-bottom:-30px;">
        <img *ngIf="logo != null"  src="{{logo}}" class="logo" alt="Responsive image">
    </div> -->
    <div class="p-col-12  p-col-align-start  " id= "tableRelatorioEmailDetalhado">
        <div class="box text-center shadow-lg p-2 mb-2 bg-white rounded" style="min-height: 450px !important;">
            <div class=" mx-3 text-left">
                <span class=" mx-4 text-center font-weight-bolder text-success shadow">
                    <h2> Relatório Detalhado de Eventos
                    <br>
                    </h2>
                </span>
                </div>
                <div class="mx-2 text-right">
                    <button class="btn btn-outline-secondary" (click)="exportParaExcel()" pTooltip="Salvar planilha de emails da eleição">
                        <i class="fas fa-save"></i>
                    </button>
                </div>
            <div class="table-responsive">
                <ul class="px-3">
                    <h4 class="mb-4">Relação de eventos</h4>
                <table class="table table-fixed table-bordered">           
                    <thead>
                        <tr>
                            <th scope="col" style="width:10%">Status</th>
                            <th scope="col" style="width:10%">Mensagem</th>
                            <th scope="col" style="width:10%">Data Evento</th>
                            <th scope="col" style="width:10%">Hora Evento</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let e of eventos" [ngClass]="'bntpo'">
                            <td>{{e.status}}</td> <!--Nome eleitor aqui!-->
                            <td>{{e.mensagem}}</td>
                            <td>{{separarDataHora(e).data}}</td>
                            <td>{{separarDataHora(e).hora}}</td>
                        </tr>
                    </tbody>
                </table>
                <hr>
                <div class="mx-3 text-left">
                    <p>- </p>
                </div>
                </ul>
            </div>
        </div>
    </div>
</div>